import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker, DateTimePicker } from '@material-ui/pickers';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import Icon from '../../Icons';

interface Props {
  name: string;
  placeholder: string;
  timePicker?: boolean;
  value?: Date | null;
  changeHandler?: Function;
  inputRef?: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontFamily: 'Source Sans Pro, sans-serif',
      '& input': {
        border: '1px solid #e4e4e4',
        padding: '8px 16px 8px 45px !important',
        fontSize: '14px',
        fontFamily: 'Source Sans Pro, sans-serif',
        color: '#4a4a4a',
        outline: 'none',
        cursor: 'pointer',
        maxWidth: '80px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
  }),
);

export default function MaterialUIPickers(props: Props) {
  const classes = useStyles();
  const { name, placeholder, value, changeHandler, inputRef } = props;
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(value || null);

  React.useEffect(() => {
    if (value) {
      setSelectedDate(value);
    }
  }, [value]);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    if (changeHandler) {
      changeHandler(date);
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justifyContent="space-around">
        <span className="absolute l15 t7">
          <Icon name="calendar"></Icon>
        </span>

        {(props.timePicker && (
          <DateTimePicker
            margin="none"
            inputRef={inputRef}
            id={name}
            format="MM/dd/yyyy HH:mm"
            value={selectedDate}
            onChange={handleDateChange}
            emptyLabel={placeholder}
            inputVariant="outlined"
            maxDate={new Date().toString()}
            className={classes.root}
          />
        )) || (
          <DatePicker
            margin="none"
            inputRef={inputRef}
            id={name}
            format="MM/dd/yyyy"
            value={selectedDate}
            onChange={handleDateChange}
            emptyLabel={placeholder}
            inputVariant="outlined"
            maxDate={new Date().toString()}
            className={classes.root}
          />
        )}
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
